// HokClaw 授权码管理接口
import { edataUserApi } from '@/utils/http/index.js'

// 授权码分页列表
export function getAgentAuthCodePage(params) {
  return edataUserApi({
    url: '/agentAuthCode/page',
    method: 'get',
    params
  })
}

// 新增授权码
export function addAgentAuthCode(data) {
  return edataUserApi({
    url: '/agentAuthCode/create',
    method: 'post',
    data
  })
}

// 禁用/启用授权码
export function disableAgentAuthCode(id) {
  return edataUserApi({
    url: `/agentAuthCode/disable/${id}`,
    method: 'post'
  })
}

// 删除授权码
export function deleteAgentAuthCode(id) {
  return edataUserApi({
    url: `/agentAuthCode/delete/${id}`,
    method: 'delete'
  })
}
